import { useState } from "react";
import { MessageSquare, ArrowUp, X } from "lucide-react";

export const FloatingWidgets = () => {
  const [visible, setVisible] = useState(true);
  const scrollTop = () =>
    window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <>
      {/* Book Online floating pill */}
      {visible && (
        <a
          href="#packages"
          data-testid="floating-book-online"
          className="hidden md:block fixed bottom-32 right-5 z-40 group"
        >
          <div className="flex items-center bg-sky-500 hover:bg-sky-600 text-white rounded-full pl-1 pr-4 py-1 shadow-2xl">
            <span className="bg-white text-sky-600 text-[10px] font-bold uppercase px-2 py-1 rounded-full">
              Book Online
            </span>
            <span className="text-[12px] font-semibold ml-3 leading-tight">
              365 days, 24×7
              <br />
              <span className="text-[10px] font-normal">from your city!</span>
            </span>
          </div>
          <button
            onClick={(e) => {
              e.preventDefault();
              setVisible(false);
            }}
            className="absolute -top-2 -right-2 w-5 h-5 rounded-full bg-white text-gray-500 hover:text-red-500 flex items-center justify-center shadow"
            aria-label="close"
          >
            <X className="w-3 h-3" />
          </button>
        </a>
      )}

      {/* Quick Enquiry tab — compact FAB on mobile, pill on desktop */}
      <a
        href="#contact"
        data-testid="floating-quick-enquiry"
        className="fixed bottom-16 right-5 z-40 bg-[var(--yellow)] hover:bg-[var(--yellow-2)] text-[var(--navy)] hover:text-white w-11 h-11 justify-center md:w-auto md:h-auto md:px-4 md:py-2 rounded-full md:rounded-md font-semibold text-sm shadow-2xl flex items-center gap-2 transition-colors"
        aria-label="Quick Enquiry"
      >
        <MessageSquare className="w-4 h-4" />
        <span className="hidden md:inline">Quick Enquiry</span>
      </a>

      {/* Scroll to top */}
      <button
        type="button"
        onClick={scrollTop}
        data-testid="scroll-top-btn"
        aria-label="scroll to top"
        className="fixed bottom-5 right-5 z-40 w-9 h-9 rounded-full bg-white border border-gray-300 hover:bg-[var(--yellow)] text-[var(--navy)] flex items-center justify-center shadow-lg transition-colors"
      >
        <ArrowUp className="w-4 h-4" />
      </button>
    </>
  );
};
